import React, { useState } from "react";
import PropTypes from "prop-types"; // Import PropTypes
import Modal from "../../Modal/Modal";
import Button from "../../atoms/Button/Button";
import Text from "../../atoms/Text/Text";
import { useTranslation } from "react-i18next";
import "./bookingButton.scss"; // Ensure you have created and imported bookingButton.scss
import Icon from "../../atoms/Icon/Icon";

const BookingButton = ({ link, showCategoryModal = false }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();
  const [iframeUrl, setIframeUrl] = useState(null);

  const handleButtonClick = () => {
    setModalOpen(true);
  };

  const handleBookingOption = (url) => {
    setIframeUrl(url);
  };

  return (
    <>
      <Button
        variant="primary"
        className="booking-btn"
        onClick={handleButtonClick}
        aria-label="Book an appointment"
      >
        <Icon name="spa" label="Flower Icon" className={"spa-icon"} />
        <Text variant="p" className="booking-text">{t("treatments.booknow")}</Text>
      </Button>
      {isModalOpen && (
        <Modal onClose={() => { setModalOpen(false); setIframeUrl(null); }}>
          {showCategoryModal ? (
            iframeUrl ? (
              <iframe
                src={iframeUrl}
                title="Booking Widget"
                className="booking-iframe"
                allow="fullscreen"
              ></iframe>
            ) : (
              <div className="booking-modal-options">
                <Text variant="h3" className="booking-modal-title">
                  {t("Kies een categorie")}
                </Text>
                <Button
                  variant="secondary"
                  className="booking-modal-btn"
                  onClick={() => handleBookingOption("https://headwellness.zohobookings.eu/portal-embed#/headspa")}
                >
                  Head Spa / Mesotherapy
                </Button>
                <Button
                  variant="secondary"
                  className="booking-modal-btn"
                  onClick={() => handleBookingOption("https://headwellness.zohobookings.eu/portal-embed#/massages")}
                >
                  Massages
                </Button>
                <Button
                  variant="secondary"
                  className="booking-modal-btn"
                  onClick={() => handleBookingOption("https://headwellness.zohobookings.eu/portal-embed#/combideals")}
                >
                  Combi Deals
                </Button>
              </div>
            )
          ) : (
            <iframe
              src={link}
              title="Booking Widget"
              className="booking-iframe"
              allow="fullscreen"
            ></iframe>
          )}
        </Modal>
      )}
    </>
  );
};

// Define the prop types for the BookingButton
BookingButton.propTypes = {
  link: PropTypes.string.isRequired,
  showCategoryModal: PropTypes.bool,
};

export default BookingButton;
